import { FC, useCallback } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalHeaderRow,
  ModalTitle,
} from './styles'

export const ChooseAkiStatusRefusedModal: FC = () => {
  const { t } = useTranslation()
  const modal = useModal()
  const history = useHistory()

  const handleClose = useCallback(() => {
    modal.hide()
    history.goBack()
  }, [modal, history])

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{t('choose_aki_status.modal.refused_title')}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('choose_aki_status.modal.close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalDescription>
        {t('choose_aki_status.modal.refused_description')}
      </ModalDescription>
      <ModalActions>
        <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={handleClose}>
          {t('choose_aki_status.modal.close_button')}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  )
}
import { FC, useCallback } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalHeaderRow,
  ModalTitle,
} from './styles'

export const ChooseAkiStatusRefusedModal: FC = () => {
  const { t } = useTranslation()
  const modal = useModal()
  const history = useHistory()

  const handleClose = useCallback(() => {
    modal.hide()
    history.goBack()
  }, [modal, history])

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{t('choose_aki_status.modal.refused_title')}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('choose_aki_status.modal.close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalDescription>
        {t('choose_aki_status.modal.refused_description')}
      </ModalDescription>
      <ModalActions>
        <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={handleClose}>
          {t('choose_aki_status.modal.close_button')}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  )
}
